import styled, { css } from 'styled-components';

export const Top = styled.div`
    padding-bottom: 1.5rem;

    p {
        margin-top: 0;
    }
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        margin: 0 0 1.5rem 0;
        color: ${theme.colors.accents[5].hex};

        @media ${theme.breakpoints.large.media} {
            margin-bottom: 2rem;
        }
    `}
`;

export const Listing = styled.ul`
    ${({ theme }) => css`
        list-style-type: none;
        padding: 0;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        gap: 1rem;

        @media ${theme.breakpoints.medium.media} {
            gap: 1.5rem;
        }
    `}
`;

export const ListItem = styled.li`
    ${({ theme }) => css`
        grid-column-start: span 12;

        @media ${theme.breakpoints.medium.media} {
            grid-column-start: span 6;
        }

        @media ${theme.breakpoints.large.media} {
            grid-column-start: span 3;
        }
    `}
`;
